import { generateId } from '@freelancer/datastore/testing/helpers';
import type { AdminExternalCredentialProvider } from './admin-external-credential-providers.model';

export interface GenerateAdminExternalCredentialProviderOptions {
  readonly id?: number;
  readonly enterpriseId?: number;
  readonly name?: string;
  readonly maxExpiryTtlSeconds?: number;
}

export function generateAdminExternalCredentialProviderObject({
  id = generateId(),
  enterpriseId = generateId(),
  name = 'providername',
  maxExpiryTtlSeconds = undefined,
}: GenerateAdminExternalCredentialProviderOptions): AdminExternalCredentialProvider {
  return {
    id,
    enterpriseId,
    name,
    maxExpiryTtlSeconds,
  };
}
